/** Simulation tick rate (Hz) — GDD: 30 Hz sim. */
export const TICK_RATE = 30;
export const TICK_MS = 1000 / TICK_RATE;
/** Snapshot interval — GDD: 20 Hz snapshots. */
export const PATCH_RATE_MS = 50;
/** Lag-compensation cap for skill-shot rewind. */
export const MAX_REWIND_MS = 150;
/** Remote players are rendered this far behind the server. */
export const INTERPOLATION_DELAY_MS = 100;

export const MAX_PLAYERS = 12;
export const MIN_PLAYERS_TO_START = 2;

export const PLAYER_RADIUS = 30;
export const PLAYER_BASE_HP = 100;
/** Walking speed in units/s. */
export const PLAYER_MOVE_SPEED = 220;

/** Above this slide speed a player cannot walk (it can still cast). */
export const KNOCKBACK_CONTROL_THRESHOLD = 120;
/** Proportional slide damping per second (v *= 1 - FRICTION_DAMPING * dt). */
export const FRICTION_DAMPING = 2;
/** Constant slide deceleration in units/s²; guarantees a body comes to rest in bounded time. */
export const FRICTION_DECEL = 80;
/** Slide speeds below this snap to zero. */
export const REST_SPEED = 2;
/** Share of the relative normal velocity transferred in a player-player collision. */
export const COLLISION_MOMENTUM_TRANSFER = 0.5;

/** Share of the normal slide speed a warlock keeps when it bounces off an obstacle. */
export const OBSTACLE_RESTITUTION = 0.3;
/** A pillar the lava reaches flashes this long before it is removed. */
export const OBSTACLE_SINK_WARNING_MS = 1000;
/** Spawn points sit this far inside the round's start radius. */
export const SPAWN_INSET = 120;
/** Spawn rotation keeps every spawn point at least this far (in angle) from a map pillar. */
export const SPAWN_PILLAR_MIN_ANGLE_DEG = 15;

/** GDD knockback formula: k (1.0 → a player at 0 HP takes double knockback). */
export const KB_SCALING_K = 1;
/** Total knockback resistance cap (50%). */
export const KB_RESIST_CAP = 0.5;

export const ARENA_MIN_RADIUS = 200;
/** Hard bound on any world coordinate a client may send. */
export const WORLD_LIMIT = 4000;

/** Last damage within this window gets the kill. */
export const KILL_CREDIT_WINDOW_MS = 8000;
